import script from "./UpdateAggregateBusinessModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpdateAggregateBusinessModal.vue?vue&type=script&lang=ts&setup=true"

import "./UpdateAggregateBusinessModal.vue?vue&type=style&index=0&id=552d8002&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-552d8002"]])

export default __exports__